import type { ResourcePath } from '@occ/contracts';

/**
 * Índice nodo → (cliente, sucursal).
 *
 * El RBAC con alcance necesita la cadena de pertenencia para resolver un
 * permiso (`ResourcePath`), y el control de acceso de Refine es una función
 * suelta sin acceso al estado de React. Este índice lo puebla el proveedor de
 * jerarquía cuando carga el árbol y lo lee quien lo necesite.
 */

export type NodeLocation = { clientId: string; branchId: string };

let tenantId: string | null = null;
let byNode = new Map<string, NodeLocation>();

export const setHierarchyIndex = (nextTenantId: string, locations: Map<string, NodeLocation>) => {
  tenantId = nextTenantId;
  byNode = locations;
};

export const locateNode = (nodeId: string): NodeLocation | undefined => byNode.get(nodeId);

/** `undefined` en los ids que no se conocen: el backend decidirá igualmente. */
export const nodeResourcePath = (nodeId: string): ResourcePath | null => {
  if (!tenantId) return null;
  const location = byNode.get(nodeId);
  return { tenantId, clientId: location?.clientId, branchId: location?.branchId, nodeId };
};

export const tenantResourcePath = (): ResourcePath | null => (tenantId ? { tenantId } : null);

export const clientResourcePath = (clientId: string): ResourcePath | null =>
  tenantId ? { tenantId, clientId } : null;

export const branchResourcePath = (branchId: string, clientId?: string): ResourcePath | null =>
  tenantId ? { tenantId, clientId, branchId } : null;
